export default {
  DASHBOARD: 'Dashboard',
  REWARD_DESCRIPTION: 'Reward description',
  REWARD_DETAILS: 'Reward details',
  REWARDS_SECTION_TITLE: 'Reward Categories',
  REWARD_TOTAL_TITLE: 'Your reward total is',
  REWARD_NOT_FOUND: 'This reward could not be found. Go to your %employee statement%',
  REWARD_TEXTVALUE_MORE: 'More',
};
